import { ReactNode } from "react";
import PortalUnavailable from "./features/PortalUnavailable";

type WelcomeScreen = {
	path: string;
	component: ReactNode;
}

export const enum PublicRoutes {
	signIn = "/auth/signin",
	signUp = "/auth/signup",
	forgotPassword = "/auth/forgot-password",
	welcome = "/welcome"
}

export const enum PrivateRoutes {
	permitsHome = "/home",
	permitsNew = "/home/{0}",
	permitsList = "/permits",
	permitsView = "/permits/{0}",
	permitsGroupView = "/permits/groups/{0}",
	permitsDocumentationUpdate = "/permits/{0}/documentation-update",
	holderView = "/holder",
	driverView = "/drivers/{0}",
	driverCreate = "/drivers/create",
	residenciesView = "/residencies/{0}",
	residenciesCreate = "/residencies/create",
	vehicles = "/vehicles",
	vehiclesView = "/vehicles/{0}",
	vehiclesCreate = "/vehicles/create",
	vehiclesEdit = "/vehicles/{0}/edit",
	documentsUpdate = "/documents/{0}/update",
	payments = "/payments",
	documents = "/documents",
	invoices = "/invoices",
	settings = "/settings",
}

export function formatRoute(route: string, ...params: any[]): string {
	for (let i = 0; i < params.length; ++i) {
		route = route.replace(`{${i}}`, encodeURIComponent(params[i]));
	}

	return route;
}

export const WelcomeScreens: Record<string, WelcomeScreen> = {
	"portal-unavailable": {
		path: "/unavailable",
		component: <PortalUnavailable/>
	}
}

export function getWelcomeRoutes(): WelcomeScreen[] {
	const routes: WelcomeScreen[] = [];
	for (const value of Object.values(WelcomeScreens)) {
		routes.push(value);
	}

	return routes;
}
